<script setup>
const { loading } = defineProps({
    loading: Boolean
})
</script>

<template>
    <div>
        <span v-if="loading" class="loader"></span>
        <slot v-else></slot>
    </div>
</template>

<style scoped>
@reference 'tailwindcss';
@reference '#app.css';

.loader {
    --gap: 14px;
    --height: 12px;
    
    display: block;
    box-sizing: border-box;
    animation: animloader 1s ease-in-out infinite alternate;
    transform: translateX(calc(-1.5 * var(--gap)));

    /* The dots are drawn as box-shadows, so they take the inherited text colour: callers
       set it to whatever contrasts with the background they place the loader on. */
    @apply size-2.5 rounded-full bg-transparent relative my-4 mx-auto;
}

@keyframes animloader {
    33% {
        box-shadow: var(--gap) calc(-1 * var(--height)), calc(2 * var(--gap)) 0, calc(3 * var(--gap)) 0;
    }

    66% {
        box-shadow: var(--gap) 0, calc(2 * var(--gap)) calc(-1 * var(--height)), calc(3 * var(--gap)) 0;
    }

    to {
        box-shadow: var(--gap) 0, calc(2 * var(--gap)) 0, calc(3 * var(--gap)) calc(-1 * var(--height));
    }

    from {
        box-shadow: var(--gap) 0, calc(2 * var(--gap)) 0, calc(3 * var(--gap)) 0;
    }
}
</style>